export const FETCH__USERS_RRQ_LIST = 'FETCH__USERS_RRQ_LIST';
export const FETCH__USERS_RRQ_LIST__SUCCESS = 'FETCH__USERS_RRQ_LIST__SUCCESS';
export const FETCH__USERS_RRQ_LIST__FAIL = 'FETCH__USERS_RRQ_LIST__FAIL';

export const CREATE__RRQ = 'CREATE__RRQ';
export const CREATE__RRQ__SUCCESS = 'CREATE__RRQ__SUCCESS';
export const CREATE__RRQ__FAIL = 'CREATE__RRQ__FAIL';